import { Lock } from "lucide-react";
import { useSlip } from "@/context/BetSlipContext";

export const OddsButton = ({ ev, pick, label }) => {
  const { toggle, isSelected } = useSlip();
  const odds = ev.odds?.[pick];
  const selected = isSelected(ev.id, pick);
  const disabled = !ev.bettable || !odds;
  return (
    <button
      data-testid={`odds-button-${ev.id}-${pick}`}
      disabled={disabled}
      onClick={() => toggle(ev, pick)}
      className={`flex min-w-[64px] flex-1 items-center justify-between gap-2 rounded-md border px-2.5 py-2 text-xs font-semibold transition-[background-color,border-color,color,box-shadow,transform] duration-150 active:scale-95 ${
        selected
          ? "border-[#F59E0B] bg-[#F59E0B]/20 text-[#F59E0B] shadow-[0_0_14px_rgba(245,158,11,0.25)]"
          : "border-[#1E293B] bg-[#1A2234] text-slate-200 hover:border-[#10B981]/60 hover:bg-[#242F46]"
      } disabled:cursor-not-allowed disabled:opacity-50`}
    >
      <span className="text-[10px] uppercase tracking-wider text-slate-400">{label}</span>
      {disabled ? <Lock className="h-3 w-3" /> : <span className="font-odds text-sm">{odds.toFixed(2)}</span>}
    </button>
  );
};
